// TODO - audit other functions with time parameters
//  and move common time settings into constants here
const TimeConstants = {
  SELECTION_DEBOUNCE_TIME_MS_FAST: 200,
  SELECTION_DEBOUNCE_TIME_MS: 1000,
  SELECTION_THROTTLE_TIME_MS: 1000,
  ENQUEUE_TOAST_DEBOUNCE_TIME_MS: 1500,
  ENQUEUE_TOAST_THROTTLE_TIME_MS: 3000,
  DEBOUNCE_TIME_500_MS: 500,
  INFINITY: Infinity,
  SECONDS_5: 5000,
  SECONDS_8: 8000,
  SECONDS_10: 10000,
} as const;

export default { ...TimeConstants, ERROR_TOAST_DURATION: TimeConstants.SECONDS_10 };
